import { db } from "../config/firebasedb"
export default {
   async getEvents(event_storage){
        var eventsRef = await db.collection("events")
        eventsRef.onSnapshot(snap => {
        event_storage= [];
        snap.forEach(doc => {
            var event = doc.data();
            event.id = doc.id;
            event_storage.push(event);
        });
    });
    },
    addEvent(event_data){
        return db.collection("events").add(event_data)
    },

    async addEventRegistration(event_id,data){
            const registrationRef = db.collection("events").doc(event_id).collection("registrations")
            const snapshot = await registrationRef.where('email', '==', data.email).get();
            if (snapshot.empty) {
                return registrationRef.add(data)
            } else{
                return Promise.reject(new Error("email_exist"))
            }
    },
    updateEvent(){

    },
    deleteEvent(){

    },
    registerEvent(){

    },
    // checkinAttendee(event_id,attendee_id){

    // }
    loadCheckins(event_id){
        return db.collection("events").doc(event_id).collection("registrations").where("checkin_status","==","pending").get()
    }
}